<template>
    <div id="app">
        <v-app>
            <div style="display: flex; flex-direction: column; width: 100%; height: 100%;">
                <Header ref="header" :title="$route.meta.title" v-if="$route.meta.header"/>
                <transition name="fade" mode="out-in"><router-view/></transition>
                <Footer v-if="$route.meta.footer"/>
            </div>
        </v-app>
    </div>
</template>

<script>
    import Header from "@/components/Header/Header";
    import Footer from "@/components/Footer/Footer";
    import oracle from "@/utils/oracle";

    export default {
        name: 'App',
        components: {
            Header,
            Footer,
        },
        data() {
            return {}
        },
        methods: {},
        mounted() {
        },
        beforeCreate() {
            if (!oracle.isMobile()) {
                window.location.href = 'https://cluna.app'
            }
        }
    };
</script>

<style>
    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/font/Shabnam-FD.eot');
        src: url('~@/assets/font/Shabnam-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/font/Shabnam-FD.woff2') format('woff2'),
        url('~@/assets/font/Shabnam-FD.woff') format('woff'),
        url('~@/assets/font/Shabnam-FD.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/font/Shabnam-Bold-FD.eot');
        src: url('~@/assets/font/Shabnam-Bold-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/font/Shabnam-Bold-FD.woff2') format('woff2'),
        url('~@/assets/font/Shabnam-Bold-FD.woff') format('woff'),
        url('~@/assets/font/Shabnam-Bold-FD.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/font/Shabnam-Thin-FD.eot');
        src: url('~@/assets/font/Shabnam-Thin-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/font/Shabnam-Thin-FD.woff2') format('woff2'),
        url('~@/assets/font/Shabnam-Thin-FD.woff') format('woff'),
        url('~@/assets/font/Shabnam-Thin-FD.ttf') format('truetype');
        font-weight: 100;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/font/Shabnam-Light-FD.eot');
        src: url('~@/assets/font/Shabnam-Light-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/font/Shabnam-Light-FD.woff2') format('woff2'),
        url('~@/assets/font/Shabnam-Light-FD.woff') format('woff'),
        url('~@/assets/font/Shabnam-Light-FD.ttf') format('truetype');
        font-weight: 300;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/font/Shabnam-Medium-FD.eot');
        src: url('~@/assets/font/Shabnam-Medium-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/font/Shabnam-Medium-FD.woff2') format('woff2'),
        url('~@/assets/font/Shabnam-Medium-FD.woff') format('woff'),
        url('~@/assets/font/Shabnam-Medium-FD.ttf') format('truetype');
        font-weight: 500;
    }

    * {
        font-family: Shabnam;
        letter-spacing: 0 !important;
    }

    body {
        direction: rtl;
        background-color: #f9f9fb !important;
    }

    a {
        text-decoration: none;
    }

    *:focus {
        box-shadow: none !important;
        border: none !important;
        outline: none !important;
    }

    button:focus,
    input:focus,
    textarea:focus {
        box-shadow: none !important;
        border: none !important;
        outline: none !important;
    }

    button {
        letter-spacing: 0 !important;
    }

    a:hover {
        text-decoration: none !important;
    }

    ul,
    ol {
        margin: 0 !important;
        padding: 0;
        list-style: none;
    }

    .v-application--wrap {
        background-color: #ffffff !important;
        height: 100vh;
    }

    .v-dialog {
        margin: 0 !important;
        margin-top: auto !important;
    }

    .v-dialog {
        margin: 0 !important;
        margin-top: auto !important;
    }

    .v-dialog:first-child {
        width: 100% !important;
    }

    .v-text-field__slot {
        font-size: 19px !important;
    }

    ::placeholder {
        font-size: 15px !important;
    }

    ::-webkit-input-placeholder {
        font-size: 15px !important;
    }

    :-moz-placeholder {
        font-size: 15px !important;
    }

    ::-moz-placeholder {
        font-size: 15px !important;
    }

    :-ms-input-placeholder {
        font-size: 15px !important;
    }

    .v-tab {
        font-size: 12px !important;
        font-family: Shabnam !important;
    }

    .multi-line {
        white-space: pre-line !important;
        word-wrap: break-word;
    }

    .single-line {
        white-space: nowrap !important;
        word-wrap: break-word;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active {
        transition: opacity 1s ease;
    }

    .fade-leave {

    }

    .v-input--selection-controls__input {
        margin-left: 5px;
    }

    .fade-leave-active {
        transition: opacity 1s ease;
        opacity: 0;
    }

    .v-snack, .v-snack__wrapper {
        z-index: 1000000 !important;
    }

    .swal2-content {
        font-size: 13px !important;
    }

    .swal2-confirm {
        font-size: 13px !important;
        font-weight: bold !important;
    }

    .center-cropped {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        object-position: center center;
        object-fit: cover;
        overflow: hidden
    }
</style>
